<div class="dashboard-container w-full">
  <ng-content></ng-content>
</div>
